import type { InputHTMLAttributes } from "react";

import { cn } from "@/lib/utils/cn";

export function Input({ className, ...props }: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      data-ui="input"
      className={cn(
        "h-9 min-w-0 w-full rounded-md border border-border bg-background px-3 text-sm leading-5 text-foreground outline-none transition-colors duration-150 placeholder:text-muted-foreground hover:border-muted-foreground/60 focus:border-primary focus:ring-2 focus:ring-primary/20 disabled:cursor-not-allowed disabled:bg-muted disabled:text-muted-foreground aria-invalid:border-destructive aria-invalid:focus:ring-destructive/20",
        className,
      )}
      {...props}
    />
  );
}
